<template>
    <div class="place-detail">
        <ul class="nav nav-tabs">
            <li class="nav-item"><a class="active" data-toggle="tab" href="#fromstart">Điểm đón</a></li>
            <li class="nav-item"><a data-toggle="tab" href="#toend">Điểm trả</a></li>
        </ul>
        <div class="tab-content tab-content-place pt-3">
            <div id="fromstart" class="tab-pane fade show active">
                <div class="place-height">
                    <div class="pb-1 pr-0 form-group pickup" v-for="(pickup, key) in v.pickupLocations.$each.$iter" :key="key">
                        <label class="col-md-12 pl-0 pr-0 pt-1 col-sm-3 control-label text-left mb-0 font-weight-bold">Điểm đón và số người đón<span style="color:red;">*</span>:</label>
                        <div class="location-group">
                            <selector-place class="select-pickup" :value="pickup.address.$model"
                                            @input="pickup.$model = {...$event, people_quantity: pickup.people_quantity.$model}; pickup.address.$model = getProp($event, 'address', '')">
                            </selector-place>
                            <input type="number"
                                   class="form-control input-vxr ml-1 people-quantity-pickup"
                                   :value="pickup.people_quantity.$model"
                                   @input="pickup.people_quantity.$model = $event.target.value; pickup.$model = {...pickup.$model, people_quantity: $event.target.value}"
                                   placeholder="Số lượng">

                            <img v-if="key !== '0'"
                                 @click="removeItemLocation('pickup', key)"
                                 class="ml-1 btn-minus" src="../../../../assets/images/minus-icon.svg" alt="">
                        </div>
                        <div v-if="pickup.address.$error || pickup.people_quantity.$error">
                            <span class="error" v-if="!pickup.address.required">Điểm đón không được để trống</span>
                            <span class="error" v-if="!pickup.people_quantity.minValue">Số lượng người đón phải lớn hơn 1</span>
                            <span class="error" v-if="!pickup.people_quantity.required">Số lượng không được để trống</span>
                        </div>
                    </div>
                    <div>
                        <button type="button" class="btn btn-primary btn-plus" @click="addItemLocation('pickup')">Thêm điểm đón</button>
                    </div>
                </div>
            </div>
            <div id="toend" class="tab-pane fade">
                <div class="place-height">
                    <div class="pb-1 pr-0 form-group" v-for="(getOff, key) in v.getOffLocations.$each.$iter" :key="key">
                        <label class="col-md-12 pl-0 pr-0 pt-1 col-sm-3 control-label text-left mb-0 font-weight-bold">Điểm trả<span style="color:red;">*</span>:</label>
                        <div class="location-group">
                            <input type="text"
                                   class="form-control input-vxr input-get-off"
                                   placeholder="Nhập điểm trả"
                                   :value="getOff.address.$model"
                                   @input="getOff.address.$model = $event.target.value; getOff.$model = {...{}, address: $event.target.value}">

                            <img v-if="key !== '0'"
                                 @click="removeItemLocation('getOff', key)"
                                 class="ml-1 btn-minus" src="../../../../assets/images/minus-icon.svg" alt="">
                        </div>

                        <div v-if="getOff.address.$error">
                            <span class="error" v-if="!getOff.address.required">Điểm trả không được để trống</span>
                        </div>
                    </div>
                    <div>
                        <button type="button" class="btn btn-primary btn-plus" @click="addItemLocation('getOff')">Thêm điểm trả</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { SelectorPlace } from "../../../shared/components";
    import {MixinHelper} from "../../../shared/services";

    export default {
        name: "PlaceDetail",
        mixins: [MixinHelper],
        components: {SelectorPlace},
        props: {
            value: {
                type: Object,
                default: function () {
                    return {
                        pickupLocations: [],
                        getOffLocations: []
                    }
                }
            },
            v: {
                type: Object,
                required: true
            }
        },
        created() {
            // this.addPickup();
        },
        methods: {
            emitVal() {
                this.$emit('input', this.value);
            }
        },
    }
</script>

<style scoped>
    .place-detail .nav-tabs li {
        float: left;
        margin-bottom: -1px;
        width: 50%;
        text-align: center;
        text-transform: uppercase;
        font-weight: 700;
        border-radius: 5px 5px 0 0;
    }

    .place-detail .nav-tabs li a.active {
        color: #333;
        cursor: default;
        background-color: #fff;
        border: 1px solid #eee;
        border-bottom-color: transparent;
        border-radius: 5px 5px 0 0;
        border-top: 4px solid #1867BC;
    }

    .nav > li > a {
        padding: 10px 15px;
        color: #8C8C8C;
        width: 100%;
        display: block;
        position: relative;
    }

    li {
        list-style: none;
    }

    a:hover {
        text-decoration: none;
    }

    .pickup {
        position: relative;
    }

    .place-height {
        height: 200px;
    }
    .location-group {
        display: flex;
        flex-flow: row wrap;
        align-items: center;
    }
    .people-quantity-pickup {
        width: 20%;
        height: 40px;
        font-size: 12px;
    }
    input.people-quantity-pickup:focus {
        outline: none !important;
    }
    .location-group .select-pickup {
        width: 68%;
    }
    .btn-plus {
        font-size: 14px;
    }
    .tab-content-place {
        overflow-y: scroll;
    }
    .location-group .input-get-off {
        width: 90%;
    }
    .btn-minus {
        cursor: pointer;
        width: 5%;
        background-color: #fff;
        border: none
    }
</style>
